import styled from "styled-components";
import {MobileMenuItemContainerBox} from "../../boxes/mobile-menu-item-container.box";
import {CssRule} from "../../../../themes/architecture/css-helpers/css-rule";

export const MobileLangSwitcherContainerBox = styled(MobileMenuItemContainerBox)`
  &::after {
    content: "";
    background-image: url("${props => props.theme.images.spriteSheet.toString()}");
    background-position: -780px -654px;
    background-repeat: no-repeat;
    width: 1.5rem;
    height: 1.5rem;
    margin: 0 1rem;
    ${CssRule.For.RTL.build()} & {
      transform: scaleX(-1);
    }
  }
  
  
`